import { defineStore } from 'pinia';
import { ref } from 'vue';

export class Pagination {
    constructor(list, page, perPage, order, filters = new Map()) {
        this.page = page;
        this.perPage = perPage;
        this.list = list;
        this.order = order;
        this.filters = filters
    }
}

export const usePaginationStore = defineStore('pagination', () => {
    const pagination = ref(Array())

    return {
        pagination
    }
})